import React from 'react';
import './ScrollProgressBar.css';

const ScrollProgressBar = ({ progress = 0 }) => {
  return (
    <div className="scroll-progress-container">
      <div 
        className="scroll-progress-bar"
        style={{ 
          opacity: progress > 0 ? 1 : 0,
          transition: 'opacity 0.3s ease'
        }}
      >
        <div 
          className="scroll-progress-fill"
          style={{ 
            width: `${progress * 100}%`,
            marginLeft: '50%',
            transform: 'translateX(-50%)'
          }}
        />
      </div>
      <div className="scroll-progress-text">
        {Math.round(progress * 100)}% Complete
      </div>
    </div>
  );
};

export default ScrollProgressBar;
